// #ifdef H5
import {
	showDialog
} from 'vant';
// #endif
// #ifdef APP-PLUS
import Fy from '@/js_sdk/fy-showModal/index.js'
// #endif
const xc = {
	navigateTo: function(url) {
		uni.navigateTo({
			url
		})
	},
	toast: function(text) {
		// // #ifdef H5
		// text && uni.showModal({
		// 	title: '温馨提示',
		// 	content: text,
		// 	showCancel: false,
		// 	confirmText:'我知道了'
		// })
		// // #endif

		if (text) {
			// #ifdef H5
			if (text.length > 8) {
				return xc.modal(text)
			}
			// #endif
			// #ifndef H5
			if (text.length > 8) {
				return xc.modal(text)
			}
			// #endif
			uni.showToast({
				title: text,
				icon: 'none',
				duration: 3000
			})
		}

	},
	modal: function(content, title, callback, confirmText, showCancel, confirmColor, cancelColor, cancelText) {
		// #ifdef H5
		showDialog({
				title: title || '温馨提示',
				message: content,
				showCancelButton: showCancel || false,
				confirmButtonText: confirmText || "我知道了",
				confirmButtonColor: confirmColor || "#FF0000",
				cancelButtonColor: cancelColor || "#7F7F7F",
				cancelButtonText: cancelText || '取消',
				messageAlign: 'left'
			}).then(() => {
				// on confirm
				callback && callback(true)
			})
			.catch(() => {
				// on cancel
				callback && callback(false)
			})
		// #endif
		// #ifdef APP-PLUS
		Fy.showModal({
			title: title || '温馨提示',
			content: content,
			showCancel: showCancel || false,
			// #ifndef MP-TOUTIAO
			cancelColor: cancelColor || "#7F7F7F",
			confirmColor: confirmColor || "#ff0000",
			// #endif
			confirmText: confirmText || "确定",
			cancelText: cancelText || '取消',
			backbutton: true
		}).then(() => {
			callback && callback(true)
		}).catch(() => {
			callback && callback(false)
		})
		// #endif
		// #ifndef H5 || APP-PLUS
		uni.showModal({
			title: title || '温馨提示',
			content: content,
			showCancel: showCancel || false,
			// #ifndef MP-TOUTIAO
			cancelColor: cancelColor || "#7F7F7F",
			confirmColor: confirmColor || "#FF0000",
			// #endif
			confirmText: confirmText || "我知道了",
			cancelText: cancelText || '取消',
			success(res) {
				if (res.confirm) {
					callback && callback(true)
				} else {
					callback && callback(false)
				}
			},
			fail(err) {
				console.log(err)
			}
		})
		// #endif
	},
	href(url, isMain) {
		if (isMain) {
			uni.switchTab({
				url: url
			})
		} else {
			uni.navigateTo({
				url: url
			});
		}
	},
	// #ifdef H5
	jsonp: function(url, callback, callbackname) {
		window[callbackname] = callback;
		let script = document.createElement("script");
		script.src = url;
		script.type = "text/javascript";
		document.head.appendChild(script);
		document.head.removeChild(script);
	},
	/**
	 * 获取query参数
	 * @returns {String}
	 */
	getQueryParam(key) {
		var value
		var paramStr = window.location.search ? window.location.search.substr(1) : ''
		if (paramStr) {
			paramStr.split('&').forEach(function(param) {
				var arr = param.split('=')
				if (arr[0] === key) {
					console.log('解码前', arr[1])
					console.log('解码后', decodeURI(arr[1]))
					value = decodeURI(arr[1])
				}
			})
		}
		return value
	},
	/**
	 * query设置指定参数
	 * @returns {String}
	 */
	setQueryParam(param, value) {
		var query = location.search.substring(1)
		var p = new RegExp('(^|)' + param + '=([^&]*)(|$)')
		if (p.test(query)) {
			var firstParam = query.split(param)[0]
			var secondParam = query.split(param)[1]
			if (secondParam.indexOf('&') > -1) {
				var lastPraam = secondParam.substring(secondParam.indexOf('&') + 1)
				return '?' + firstParam + param + '=' + value + '&' + lastPraam
			} else {
				if (firstParam) {
					return '?' + firstParam + param + '=' + value
				} else {
					return '?' + param + '=' + value
				}
			}
		} else {
			if (query === '') {
				return '?' + param + '=' + value
			} else {
				return '?' + query + '&' + param + '=' + value
			}
		}
	}
	// #endif
}



export default xc